unit SystemUserSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, WEBLib.Buttons, WEBLib.ComCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  Vcl.StdCtrls, WEBLib.StdCtrls, VCL.TMSFNCBitmapContainer;

type
  TfrmControllerEmail = class(TForm)
    WebPanel1: TPanel;
    WebPageControl1: TPageControl;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    wcContEmail: TXDataWebClient;
    dsContEmail: TDataSource;
    wdsContEmail: TXDataWebDataSet;
    wdsContEmailSLNCODE: TStringField;
    wdsContEmailSLNNAME: TStringField;
    wdsContEmailEMAIL: TStringField;
    wdsContEmailACCESSRIGHTS: TStringField;
    WebSpeedButton9: TSpeedButton;
    bmContainer: TTMSFNCBitmapContainer;
    WebPanel4: TPanel;
    WebPanel6: TPanel;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    edtPageCount: TEdit;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    dgaContEmail: TTMSFNCDataGridDatabaseAdapter;
    procedure WebFormShow(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
  private
    { Private declarations }

    iMaxPageCount, iPageCount : Integer;


    procedure LoadWorkEmail(SLNCode:String;Pagecount:Integer);

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmControllerEmail: TfrmControllerEmail;

implementation

{$R *.dfm}

uses
  stfmssystem.connection , share.system.classes , share.common;

procedure TfrmControllerEmail.LoadWorkEmail(SLNCode: String;
  Pagecount: Integer);
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      LoadWorkEmail(SLNCode,Pagecount);
    end;

  procedure OnSuccessView(Response : TXDataClientResponse);
    begin
      wdsContEmail.Close;
      wdsContEmail.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsContEmail.Open;

    end;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      iMaxPageCount := Integer(TJSObject(Response.Result)['value']);

      edtPageCount.Text := IntToStr(iPageCount) + ' of ' + IntToStr(iMaxPageCount);

      sJson := '{"PageCount":' + IntToStr(iPageCount) + ',"SLNCode":"*"}';

      wcContEmail.RawInvoke('IstfmsSystemService.Get_WorkEmail_View',[sJson],@OnSuccessView,@OnError);
    end;

begin
  wcContEmail.RawInvoke('IstfmsSystemService.Get_WorkEmail_MaxPC',[],@OnSuccess,@OnError);
end;

procedure TfrmControllerEmail.WebFormShow(Sender: TObject);
begin
  iPageCount := 1;

  LoadWorkEmail('*',iPageCount);
end;

procedure TfrmControllerEmail.WebSpeedButton1Click(Sender: TObject);
begin
  wdsContEmail.First;
end;

procedure TfrmControllerEmail.WebSpeedButton2Click(Sender: TObject);
begin
  wdsContEmail.Prior;
end;

procedure TfrmControllerEmail.WebSpeedButton3Click(Sender: TObject);
begin
  wdsContEmail.Next;
end;

procedure TfrmControllerEmail.WebSpeedButton4Click(Sender: TObject);
begin
  wdsContEmail.Last;
end;

procedure TfrmControllerEmail.WebSpeedButton5Click(Sender: TObject);
begin
  if iPageCount < iMaxPageCount then
    Begin
      Inc(iPageCount);
      LoadWorkEmail('*',iPageCount);
    End;
end;

procedure TfrmControllerEmail.WebSpeedButton6Click(Sender: TObject);
begin
  iPageCount := iMaxPageCount;
  LoadWorkEmail('*',iPageCount);
end;

procedure TfrmControllerEmail.WebSpeedButton7Click(Sender: TObject);
begin
  iPageCount := 1;

  LoadWorkEmail('*',iPageCount);
end;

procedure TfrmControllerEmail.WebSpeedButton8Click(Sender: TObject);
begin
  if iPageCount > 1 then
    Begin
      Dec(iPageCount,1);
      LoadWorkEmail('*',iPageCount);
    End;
end;

procedure TfrmControllerEmail.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPageControl1 := TPageControl.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  edtPageCount := TEdit.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  dgaContEmail := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  bmContainer := TTMSFNCBitmapContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  wcContEmail := TXDataWebClient.Create(Self);
  dsContEmail := TDataSource.Create(Self);
  wdsContEmail := TXDataWebDataSet.Create(Self);
  wdsContEmailSLNCODE := TStringField.Create(Self);
  wdsContEmailSLNNAME := TStringField.Create(Self);
  wdsContEmailEMAIL := TStringField.Create(Self);
  wdsContEmailACCESSRIGHTS := TStringField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPageControl1.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  edtPageCount.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  dgaContEmail.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  bmContainer.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  wcContEmail.BeforeLoadDFMValues;
  dsContEmail.BeforeLoadDFMValues;
  wdsContEmail.BeforeLoadDFMValues;
  wdsContEmailSLNCODE.BeforeLoadDFMValues;
  wdsContEmailSLNNAME.BeforeLoadDFMValues;
  wdsContEmailEMAIL.BeforeLoadDFMValues;
  wdsContEmailACCESSRIGHTS.BeforeLoadDFMValues;
  try
    Name := 'frmControllerEmail';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPageControl1.SetParentComponent(WebPanel1);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 0;
    WebPageControl1.Top := 113;
    WebPageControl1.Width := 640;
    WebPageControl1.Height := 367;
    WebPageControl1.Align := alClient;
    WebPageControl1.TabIndex := 0;
    WebPageControl1.ShowTabs := False;
    WebPageControl1.TabOrder := 0;
    WebPanel4.SetParentComponent(WebPageControl1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 0;
    WebPanel4.Width := 640;
    WebPanel4.Height := 367;
    WebPanel4.Align := alClient;
    WebPanel4.TabOrder := 0;
    WebPanel6.SetParentComponent(WebPanel4);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 0;
    WebPanel6.Top := 307;
    WebPanel6.Width := 640;
    WebPanel6.Height := 60;
    WebPanel6.Align := alBottom;
    WebPanel6.ChildOrder := 6;
    WebPanel6.Color := clSilver;
    WebPanel6.TabOrder := 0;
    WebSpeedButton6.SetParentComponent(WebPanel6);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 245;
    WebSpeedButton6.Top := 20;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := '>>';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 0;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton5.SetParentComponent(WebPanel6);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 215;
    WebSpeedButton5.Top := 20;
    WebSpeedButton5.Width := 24;
    WebSpeedButton5.Height := 24;
    WebSpeedButton5.Caption := '>';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 1;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    edtPageCount.SetParentComponent(WebPanel6);
    edtPageCount.Name := 'edtPageCount';
    edtPageCount.Left := 88;
    edtPageCount.Top := 22;
    edtPageCount.Width := 121;
    edtPageCount.Height := 22;
    edtPageCount.ChildOrder := 1;
    edtPageCount.HeightPercent := 100.000000000000000000;
    edtPageCount.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebPanel6);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 58;
    WebSpeedButton8.Top := 20;
    WebSpeedButton8.Width := 24;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := '<';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 3;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebSpeedButton7.SetParentComponent(WebPanel6);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 28;
    WebSpeedButton7.Top := 20;
    WebSpeedButton7.Width := 24;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Caption := '<<';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 4;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    TMSFNCDataGrid1.SetParentComponent(WebPanel4);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 0;
    TMSFNCDataGrid1.Width := 640;
    TMSFNCDataGrid1.Height := 307;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 1;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := dgaContEmail;
    TMSFNCDataGrid1.BitmapContainer := bmContainer;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 6;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CODE';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'NAME';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'EMAIL';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ACCESSRIGHTS';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('SystemUserSetup.WebPanel4.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('SystemUserSetup.WebPanel4.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('SystemUserSetup.WebPanel4.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('SystemUserSetup.WebPanel4.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('SystemUserSetup.WebPanel4.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('SystemUserSetup.WebPanel4.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('SystemUserSetup.WebPanel4.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('SystemUserSetup.WebPanel4.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('SystemUserSetup.WebPanel4.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    TMSFNCDataGrid1.RowCount := 1;
    dgaContEmail.SetParentComponent(TMSFNCDataGrid1);
    dgaContEmail.Name := 'dgaContEmail';
    dgaContEmail.Left := 28;
    dgaContEmail.Top := 40;
    dgaContEmail.Width := 26;
    dgaContEmail.Height := 26;
    dgaContEmail.Visible := True;
    dgaContEmail.Columns.Clear;
    with dgaContEmail.Columns.Add do
    begin
      FieldName := 'SLNCODE';
      Header := 'CODE';
      AutoCreated := False;
    end;
    with dgaContEmail.Columns.Add do
    begin
      FieldName := 'SLNNAME';
      Header := 'NAME';
      AutoCreated := False;
    end;
    with dgaContEmail.Columns.Add do
    begin
      FieldName := 'EMAIL';
      Header := 'EMAIL';
      AutoCreated := False;
    end;
    with dgaContEmail.Columns.Add do
    begin
      FieldName := 'ACCESSRIGHTS';
      Header := 'ACCESSRIGHTS';
      AutoCreated := False;
    end;
    with dgaContEmail.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dgaContEmail.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dgaContEmail.DataSource := dsContEmail;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'System User Setup';
    WebPanel2.ChildOrder := 1;
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 1;
    bmContainer.SetParentComponent(WebPanel2);
    bmContainer.Name := 'bmContainer';
    bmContainer.Left := 456;
    bmContainer.Top := 16;
    bmContainer.Width := 26;
    bmContainer.Height := 26;
    bmContainer.Visible := True;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 60;
    WebPanel3.Width := 640;
    WebPanel3.Height := 53;
    WebPanel3.Align := alTop;
    WebPanel3.ChildOrder := 2;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 2;
    WebSpeedButton1.SetParentComponent(WebPanel3);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 24;
    WebSpeedButton1.Top := 16;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel3);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 56;
    WebSpeedButton2.Top := 16;
    WebSpeedButton2.Width := 24;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel3);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 88;
    WebSpeedButton3.Top := 16;
    WebSpeedButton3.Width := 24;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel3);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 120;
    WebSpeedButton4.Top := 16;
    WebSpeedButton4.Width := 24;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton9.SetParentComponent(WebPanel3);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 152;
    WebSpeedButton9.Top := 16;
    WebSpeedButton9.Width := 24;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := '+';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 4;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    wcContEmail.SetParentComponent(Self);
    wcContEmail.Name := 'wcContEmail';
    wcContEmail.Connection := dmData.dbConnect;
    wcContEmail.Left := 32;
    wcContEmail.Top := 13;
    dsContEmail.SetParentComponent(Self);
    dsContEmail.Name := 'dsContEmail';
    dsContEmail.DataSet := wdsContEmail;
    dsContEmail.Left := 152;
    dsContEmail.Top := 13;
    wdsContEmail.SetParentComponent(Self);
    wdsContEmail.Name := 'wdsContEmail';
    wdsContEmail.Connection := dmData.dbConnect;
    wdsContEmail.Left := 88;
    wdsContEmail.Top := 13;
    wdsContEmailSLNCODE.SetParentComponent(wdsContEmail);
    wdsContEmailSLNCODE.Name := 'wdsContEmailSLNCODE';
    wdsContEmailSLNCODE.FieldName := 'SLNCODE';
    wdsContEmailSLNNAME.SetParentComponent(wdsContEmail);
    wdsContEmailSLNNAME.Name := 'wdsContEmailSLNNAME';
    wdsContEmailSLNNAME.FieldName := 'SLNNAME';
    wdsContEmailSLNNAME.Size := 0;
    wdsContEmailEMAIL.SetParentComponent(wdsContEmail);
    wdsContEmailEMAIL.Name := 'wdsContEmailEMAIL';
    wdsContEmailEMAIL.FieldName := 'EMAIL';
    wdsContEmailACCESSRIGHTS.SetParentComponent(wdsContEmail);
    wdsContEmailACCESSRIGHTS.Name := 'wdsContEmailACCESSRIGHTS';
    wdsContEmailACCESSRIGHTS.FieldName := 'ACCESSRIGHTS';
    wdsContEmailACCESSRIGHTS.Size := 0;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPageControl1.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    edtPageCount.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    dgaContEmail.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    bmContainer.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    wcContEmail.AfterLoadDFMValues;
    dsContEmail.AfterLoadDFMValues;
    wdsContEmail.AfterLoadDFMValues;
    wdsContEmailSLNCODE.AfterLoadDFMValues;
    wdsContEmailSLNNAME.AfterLoadDFMValues;
    wdsContEmailEMAIL.AfterLoadDFMValues;
    wdsContEmailACCESSRIGHTS.AfterLoadDFMValues;
  end;
end;

end.